import AvatarUpload from 'components/common/AvatarUpload';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import avatar from 'assets/img/profile/profileImage.jpg';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';
import {
  useUpdateSingleFileMutation,
  useUploadSingleMutation
} from 'service/uploadQuery/uploadQuery';
import { useUpdateProfileImageMutation } from 'service/authQuery/authQuery';
import { transformFileName } from 'helpers/filename-utils';

const ProfileCard = () => {
  const user = useSelector((state: RootState) => state.user.user);

  const [uploadProfilePhoto] = useUploadSingleMutation();
  const [updateProfilePhoto] = useUpdateSingleFileMutation();
  const [updateImageUrl] = useUpdateProfileImageMutation();

  const handleUpload = async (file: File) => {
    let isUploaded = false;
    const handler = user.info?.profileImage
      ? updateProfilePhoto
      : uploadProfilePhoto;
    const formDate = new FormData();
    formDate.append('file', file);
    if (typeof user.info?.profileImage === 'string') {
      formDate.append('oldFileName', transformFileName(user.info.profileImage));
    }
    try {
      const response = await handler(formDate).unwrap();
      await updateImageUrl({ url: response.fileLink }).unwrap();
      isUploaded = true;
    } catch (error) {
      console.log(error);
    }
    return Promise.resolve(isUploaded);
  };
  return (
    <Card className="h-100">
      <Card.Body>
        <div className="pb-4">
          <Row className="align-items-center g-3 g-sm-5 text-center text-sm-start">
            <Col xs={12} sm="auto">
              <AvatarUpload
                size="5xl"
                src={user.info?.profileImage || avatar}
                onChange={handleUpload}
              />
            </Col>
            <Col xs={12} sm="auto" className="flex-1">
              <h3>{user.username}</h3>
              <p className="text-body-secondary text-uppercase">
                {user.userType}
              </p>
              <small className="text-body-secondary">
                Email : {user.email}
              </small>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProfileCard;
